
















































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { IMember } from "@/models/Member.model";
import MemberForm from "@/components/admin/members/MemberForm.vue";
import FileUpload from "@/components/shared/FileUpload.vue";

@Component({ components: { MemberForm, FileUpload } })
export default class ChairmenTable extends Vue {
  get hasEditAdmins() {
    return this.$store.getters.hasEditAdmins;
  }

  @Prop()
  members!: IMember[];

  get chairman() {
    return this.members.find((member) => member.isChairman == true);
  }
  get coChairman() {
    return this.members.find((member) => member.isCoChairman == true);
  }
  get honoraryChairman() {
    return this.members.find((member) => member.isHonoraryChairman == true);
  }
  get scientificCommitteeChairman() {
    return this.members.find(
      (member) => member.isScientificCommitteeChairman == true
    );
  }

  get mainOrganizer() {
    return this.members.find((member) => member.isMainOrganizer == true);
  }

  newChairman: IMember | undefined = {};
  newCoChairman: IMember | undefined = {};
  newHonoraryChairman: IMember | undefined = {};
  newScientificCommitteeChairman: IMember | undefined = {};
  newMainOrganizer: IMember | undefined = {};

  updateChairman(member?: IMember) {
    this.$emit("updateChairman", member);
  }
  updateCoChairman(member?: IMember) {
    this.$emit("updateCoChairman", member);
  }
  updateHonoraryChairman(member?: IMember) {
    this.$emit("updateHonoraryChairman", member);
  }
  updateScientificCommitteeChairman(member?: IMember) {
    this.$emit("updateScientificCommitteeChairman", member);
  }
  updateMainOrganizer(member?: IMember) {
    this.$emit("updateMainOrganizer", member);
  }

  @Watch("members")
  onMembersUpdate() {
    this.newChairman = this.chairman;
    this.newCoChairman = this.coChairman;
    this.newHonoraryChairman = this.honoraryChairman;
    this.newScientificCommitteeChairman = this.scientificCommitteeChairman;
    this.newMainOrganizer = this.mainOrganizer;
  }

  mounted() {
    this.newChairman = this.chairman;
    this.newCoChairman = this.coChairman;
    this.newHonoraryChairman = this.honoraryChairman;
    this.newScientificCommitteeChairman = this.scientificCommitteeChairman;
    this.newMainOrganizer = this.mainOrganizer;
  }
}
